import Awesomplete from 'awesomplete';
import axios from 'axios';

const init = function () {
  if (document.getElementById("institutionId")) {
    let institutionInput = document.getElementById("institutionId");
    let institutionAwsmp = new Awesomplete(institutionInput);
    axios
      .get("/signup/institutions")
      .then(function (response) {
        institutionAwsmp.list = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};
document.addEventListener("DOMContentLoaded", init, false);
